export { default as TeamAvatarLink } from './TeamAvatarLink';
